import clsx from 'clsx';
import { Button } from '@clay-run/glaze/button';
import { Icon } from '@clay-run/glaze/icon';
import { LoadingSpinner } from '@clay-run/glaze/loading-spinner';
import { useGenerateKeystoneState, type GeneratePhase } from '../../../hooks/useGenerateKeystoneState';
import { FLOW_ICONS } from '../icons';

// Route only enqueues, so the button stays disabled after an accepted POST;
// failures surface through the global mutation-error toast.
export const GENERATE_INTELLIGENCE_LABELS: Record<GeneratePhase, string> = {
  idle: 'Generate intelligence',
  pending: 'Generating intelligence…',
  accepted: 'Generating intelligence… (30–60s, reload to check)',
  excluded: 'Excluded from generation',
  error: 'Retry generate',
};

/**
 * Empty-state "Generate intelligence" button, shared by V1
 * (`AccountIntelSummaryView`) and V2 (`AccountIntelBody` via
 * `EntityIntelligence`'s `emptyAction` slot). Native `disabled` (not Glaze
 * `loading`, which yields aria-disabled) with its own spinner.
 */
export function GenerateIntelligenceButton({ accountId, className }: { accountId: string; className?: string }) {
  const { mutate, phase, clickable } = useGenerateKeystoneState(accountId);
  const spinning = phase === 'pending' || phase === 'accepted';

  return (
    <Button
      variant="ghost"
      size="sm"
      className={clsx('self-start', className)}
      disabled={!clickable}
      onClick={() => mutate()}
      data-testid="generate-intelligence-button"
    >
      {spinning ? <LoadingSpinner size="sm" /> : <Icon type={FLOW_ICONS.refresh} size="sm" aria-hidden />}
      {GENERATE_INTELLIGENCE_LABELS[phase]}
    </Button>
  );
}
